import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import { Tooltip, Icon } from '@podiumhq/design-system';

import useMediaQuery from '../../hooks/useMediaQuery';
import { ButtonNoHoverStyles } from '../../styles';

const CreditCardDetailsToolTip = ({
  id,
  iconType = 'IconInfo',
  tipText,
  ...props
}) => {
  const isMobile = useMediaQuery();
  const [isOpen, setIsOpen] = useState(false);
  const tipProps = isMobile ? { isOpen: isOpen } : {};

  const toggleToolTip = () => {
    if (isMobile) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <span>
      <Tooltip label={tipText} {...tipProps}>
        <CreditCardDetailsToolTipIcon
          data-testid={`info-icon-${id}`}
          onClick={toggleToolTip}
          type="QuestionMark"
          boxSize="5"
          tabIndex="-1"
          color="grey.lighter"
          height="auto"
          position="static"
          margin="0px 6px 0px 6px"
        />
      </Tooltip>
    </span>
  );
};

const CreditCardDetailsToolTipIcon = styled(Icon)`
  ${ButtonNoHoverStyles};
`;

CreditCardDetailsToolTip.propTypes = {
  iconType: PropTypes.string,
  id: PropTypes.string,
  tipText: PropTypes.string,
};

export default CreditCardDetailsToolTip;
